// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .partner-audit-dialog .el-form .el-form-item .el-form-item__label {\n  margin-top: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
